window.addEventListener('scroll', function() {
    const header = document.querySelector('.Header');
    if (window.scrollY > 0) {
        header.classList.add('sticky');
    } else {
        header.classList.remove('sticky');
    }
});

// Mobile menu
(function() {
    const hamburger = document.querySelector('.hamburger-menu');
    const panel = document.querySelector('.mobile-nav-panel');
    const overlay = document.querySelector('.mobile-nav-overlay');
    const closeBtn = document.querySelector('.mobile-nav-panel__close');
    const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let previousFocus = null;

    if (!hamburger || !panel || !overlay) return;

    function openMenu() {
        previousFocus = document.activeElement;
        hamburger.classList.add('is-active');
        hamburger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
        overlay.classList.add('is-active');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        const firstFocusable = panel.querySelector(focusableSelector);
        if (firstFocusable) {
            firstFocusable.focus();
        }
    }

    function closeMenu() {
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
        overlay.classList.remove('is-active');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (previousFocus && typeof previousFocus.focus === 'function') {
            previousFocus.focus();
        } else {
            hamburger.focus();
        }
    }

    hamburger.addEventListener('click', function() {
        if (panel.classList.contains('is-active')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    overlay.addEventListener('click', closeMenu);

    if (closeBtn) {
        closeBtn.addEventListener('click', closeMenu);
    }

    document.addEventListener('keydown', function(e) {
        if (!panel.classList.contains('is-active')) {
            return;
        }

        if (e.key === 'Escape') {
            closeMenu();
            return;
        }

        if (e.key === 'Tab') {
            const focusableItems = panel.querySelectorAll(focusableSelector);
            if (!focusableItems.length) {
                return;
            }

            const firstItem = focusableItems[0];
            const lastItem = focusableItems[focusableItems.length - 1];

            if (e.shiftKey && document.activeElement === firstItem) {
                e.preventDefault();
                lastItem.focus();
            } else if (!e.shiftKey && document.activeElement === lastItem) {
                e.preventDefault();
                firstItem.focus();
            }
        }
    });
})();